import { useContext } from "react";
import { InputProjectInformationDialogContext, PageNewState } from ".";

export const useInputProjectInformationDialogState = () => {
  const { pageState, setPageState } = useContext(
    InputProjectInformationDialogContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
